import { ExecutionContext, Injectable } from '@nestjs/common';
import { Reflector } from '@nestjs/core';
import { AuthGuard } from '@nestjs/passport';
import { Observable } from 'rxjs';

import { PUBLIC_KEY } from '../decorators';

@Injectable()
export class JwtAuthGuard extends AuthGuard('jwt') {
  constructor(private readonly reflector: Reflector) {
    super();
  }

  public override canActivate(context: ExecutionContext): boolean | Promise<boolean> | Observable<boolean> {
    const { headers } = context.switchToHttp().getRequest();
    const metadata = this.reflector.getAllAndOverride(PUBLIC_KEY, [context.getHandler(), context.getClass()]);
    if (metadata === undefined || typeof metadata === 'boolean') return metadata || super.canActivate(context);
    return metadata.passThrough && headers['authorization'] ? super.canActivate(context) : true;
  }
}
